// MUI
import {createTheme, Theme, responsiveFontSizes} from '@material-ui/core/styles';

const theme: Theme = createTheme({
  palette: {
    primary: {
      main: '#003660', // UCSB navy
    },
    secondary: {
      main: '#09847A', // UCSB sea green
    },
    error: {
      main: '#C43424', // UCSB coral
    },
  },
  typography: {
    fontFamily: ['Nunito Sans', 'Century Gothic', 'sans-serif'].join(','),
    fontSize: 16,
    h1: {
      fontWeight: 800,
      fontSize: '2.375rem', // 38px/16px=2.375
      letterSpacing: '-0.1pt',
    },
    h2: {
      fontWeight: 800,
      fontSize: '1.6875rem', // 27px/16px=1.6875
      letterSpacing: '-0.1pt',
    },
    h3: {
      fontWeight: 800,
      fontSize: '1.3125rem', // 21px/16px=1.3125
    },
    h4: {
      fontWeight: 800,
      fontSize: '1rem', // 16px/16px=1
    },
    h5: {
      fontWeight: 800,
      fontSize: '0.75rem', // 12px/16px=0.75
    },
    h6: {
      fontWeight: 600,
      fontSize: '0.75rem', // 12px/16px=0.75
    }
  }
});

export default responsiveFontSizes(theme);
